<template>
  <div class="section-categories">
    <header class="header">
      <h2 class="h3">
        Browse by category
      </h2>
      <ButtonArrow
        class="link"
        :text="'See All Posts'"
        @click.native="scrollToSection"
      />
    </header>
    <div class="cat-list row">
      <nuxt-link
        v-for="cat in results" :key="cat.id" class="col col-4"
        :to="blogPostURL(cat)"
      >
        <div class="category">
          <div class="holder">
            <div class="icon">
              <Component :is="icon(cat.image)" />
            </div>
            <h3 class="h5">
              {{ cat.category }}
            </h3>
          </div>
          <Arrow class="arrow" />
        </div>
      </nuxt-link>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
import global from '@itbpbg/lms-components/src/mixins/global';
import ButtonArrow from '@itbpbg/lms-components/src/components/ButtonArrow';
import Arrow from '../../assets/svg/icon-arrow-right.svg?vue-component';

export default {
  components: {
    ButtonArrow,
    Arrow,
  },
  mixins: [global],
  props: {
    results: { type: Array, default: () => [], required: true },
    parentSlug: { type: String, default: '', required: false },
  },
  methods: {
    icon(img) {
      return img ? require(`../../assets/svg/icon-blog-${img}.svg?vue-component`) : '';
    },
    scrollToSection() {
      let yOffset;

      if (this.$store.state.layout === 'desktop') {
        yOffset = -90;
      } else {
        yOffset = this.$config.project === 'lms' ? -64 : -68;
      }

      const element = document.querySelector('#all-posts');
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      setTimeout(() => {
        window.scrollTo({ top: y, behavior: 'smooth' });
      }, 200);
    },
  },
};
</script>

<style scoped lang="scss">
.section-categories {
  margin-top: var(--spacing-160);

  .header {
    display: flex;
    justify-content: space-between;
    margin-bottom: var(--spacing-36);

    .h3 {
      margin-bottom: 0;
    }

    .link {
      cursor: pointer;
    }
  }

  .cat-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    .category {
      background: var(--main-light-shade-2);
      border-radius: 7px;
      display: flex;
      align-items: center;
      font-weight: 500;
      margin-bottom: 38px;
      font-size: 21px;
      color: var(--main-dark-shade-0);
      height: 100px;
      padding: var(--spacing-26) var(--spacing-36);

      &:nth-child(3n) {
        margin-right: 0;
      }

      .holder {
        display: flex;
        align-items: center;

        .h5 {
          margin: 0;
          font-size: 21px;
        }
      }

      .icon {
        margin-right: var(--spacing-30);

        svg {
          width: 48px;
          height: 48px;
        }
      }

      .arrow {
        transition: all var(--duration) ease;
        margin-left: var(--spacing-16);
        width: 20px;
        height: 20px;

        path[fill] {
          fill: var(--main-dark) !important;
        }
      }

      &:hover {
        .arrow {
          transform: translate(16px, 0);
        }
      }
    }
  }
}

@include bp($bp-laptop) {
  .section-categories {
    .cat-list {
      .category {
        .icon {
          margin-right: var(--spacing-8);
        }
      }
    }
  }
}

@include bp($bp-mobile) {
  .section-categories {
    margin-top: var(--spacing-80);

    .cat-list {
      .category {
        justify-content: space-between;
        padding: var(--spacing-26) var(--spacing-32);
        margin-bottom: var(--spacing-16);
      }
    }

    .header {
      flex-direction: column;
      align-items: flex-start;

      > .h3 {
        margin-bottom: var(--spacing-12);
      }
    }
  }
}
</style>
